import { DisplayField, GuestProfile } from '@mews-commander/guest-profile';
import { createHandler } from '@mews/std';

export const getKeyByDisplayField = createHandler<
    DisplayField,
    keyof Omit<GuestProfile, '__typename' | 'createdUtc' | 'fullName' | 'id' | 'imageId' | 'number' | 'updatedUtc'>
>({
    [DisplayField.AccountingCode]: 'accountingCode',
    [DisplayField.BillingCode]: 'billingCode',
    [DisplayField.BirthDate]: 'birthDate',
    [DisplayField.BirthPlace]: 'birthPlace',
    [DisplayField.CarRegistrationNumber]: 'carRegistrationNumber',
    [DisplayField.DietaryRequirements]: 'dietaryRequirements',
    [DisplayField.Email]: 'email',
    [DisplayField.FirstName]: 'firstName',
    [DisplayField.LastName]: 'lastName',
    [DisplayField.LoyaltyCode]: 'loyaltyCode',
    [DisplayField.LoyaltyMembership]: 'loyaltyMembership',
    [DisplayField.NationalityCode]: 'nationalityCode',
    [DisplayField.Occupation]: 'occupation',
    [DisplayField.Phone]: 'phone',
    [DisplayField.PreferredLanguageCode]: 'preferredLanguageCode',
    [DisplayField.SecondLastName]: 'secondLastName',
    [DisplayField.Sex]: 'sex',
    [DisplayField.TaxIdentifier]: 'taxIdentifier',
    [DisplayField.TitlePrefix]: 'titlePrefix',
});
